const initialState = {}

function servicereducer(state = initialState, action) {
    switch (action.type) {
        case 'BOOKINGID':
            return action.data
        default:
            return state
    }
}
export default servicereducer